//
import { mapActions, mapState } from 'vuex'
import { ModelForm } from '@/components/reusable_components/next'

//
import OrdererModel from '@/models/Warehouse/WhOrderer'
import Translator from '@/services/translator'
import fields from './fields'

//
export default {
    name: 'dispatch-requests-update',
    components: {
        'model-form': ModelForm,
    },
    computed: {
        //
        ...mapState('AuthModule', ['user']),

        /**
         *
         */
        formProps() {
            return {
                fields: fields({
                    g_branch_office_id: this.user.hr_employee
                        .g_branch_office_id,
                    g_branch_office_selected_id: this.branchOfficeId,
                    pch_provider_branch_offices: this.formDataBranchOffices,
                    pch_provider_id: this.formData.pch_provider_id,
                    pch_provider_id_trigger: this.setFormDataBranchOffice,
                    triggerWarehouse: this.changeWarehouseFilter,
                }),
            }
        },
    },
    data() {
        return {
            branchOfficeId: 1,

            // branch offices
            formDataBranchOffices: [],
            formData: {},
        }
    },
    methods: {
        //
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        //
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),

        /**
         *
         */
        changeWarehouseFilter(ctx) {
            this.branchOfficeId =
                ctx.getInput('of_warehouse').getSelected().g_branch_office_id ||
                this.user.hr_employee.g_branch_office_id
        },

        /**
         *
         */
        redirect() {
            this.$router.push({ name: 'orderer' })
        },

        /**
         *
         */
        reset() {
            this.branchOfficeId = this.user.hr_employee.g_branch_office_id
            this.formData = new OrdererModel()
        },

        /**
         * @description
         * Sets the form data branch office.
         *
         * @param   {Object}    ctx The form context
         */
        setFormDataBranchOffice(ctx) {
            this.formDataBranchOffices = ctx.getInput('pch_provider_id').getSelected().getProperty('branch_offices', [])
        },

        /**
         *
         */
        showError(error) {
            this.showSnackbar(
                'error',
                'Error.',
                Translator(OrdererModel, error.response.data)
            )
        },

        /**
         *
         */
        showSnackbar(type, title, message, callback) {
            this.initSnackbar(this.fillSnack(type, title, message))
            if (typeof callback === 'function') callback()
        },

        /**
         *
         */
        showSuccess() {
            this.showSnackbar(
                'success',
                'Éxito.',
                'Solicitud de abastecimiento creada.',
                this.redirect
            )
        },

        /**
         *
         */
        submit() {
            this.$refs.form.setWait(true).then(this.create)
        },

        /**
         *
         */
        create(model) {
            model
                .create()
                .then(this.showSuccess)
                .catch(this.showError)
                .then(this.$refs.form.setWait)
        },
    },
    beforeMount() {
        this.setTitleTopBar('Crear la solicitud de abastecimiento')
    },
    mounted() {
        this.reset()
    },
}
